import { useTheme } from "@stores/ThemeContext";
import ButtonComponent from "@components/ButtonComponent";
import { Sun, Moon } from "lucide-react";

export const ThemeToggleButton = () => {
  const { isDarkMode, toggleTheme } = useTheme();

  return (
    <ButtonComponent
      // onClick={toggleTheme}
      // text={isDarkMode ? "Switch to Light Mode" : "Switch to Dark Mode"}
      id="dark-mode-selection"
      color={isDarkMode ? "blue" : "darkMode"}
      withoutborder={true}
      onClick={toggleTheme}
      noTextSwap={true}
      ref={null}
      size="sm"
      width="max"
      className="whitespace-nowrap"
      icon={isDarkMode ? <Sun /> : <Moon size={20}/>}
    />
  );
};
